import React from 'react';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import ImportForm from './components/importForm';
import useCustomerState from './hooks/useCustomerState';


const CustomerImportPage = () => {
  const navigate = useNavigate(); 
  const { importCustomers } = useCustomerState();
  
  const handleImport = async (customers) => {
    const response = await importCustomers(customers);
    if(response.success) {
      message.success('Customers imported successfully!');
      navigate('/customers');
    } else {
      message.error('Failed to import customers.');
    }
  };

  return (
    <div className="import-page">
      <h3>Import Customers</h3>
      <ImportForm
        onSubmit={handleImport}
        expectedFields={['Name', 'Contact Person', 'Email', 'Address', 'City', 'State', 'Zip', 'Country']} // Define required Excel headers
      />
    </div>
  );
};

export default CustomerImportPage;
